var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"execution-steps"},[_c('ul',{staticClass:"execution-steps__list"},_vm._l((_vm.banks),function(bank){return _c('li',{key:bank.code,staticClass:"execution-steps__item"},[_c('Bank',{attrs:{"link":{
                    text: bank.name,
                    url: `/calculators/e-ipoteki/?bank=${bank.code}`
                }}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }